import React from 'react';
import { NavLink, Link, Outlet, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../Admin.css';

const MENU = [
  { path: '/admin/images', label: '📸 이미지 관리', enabled: true },
  { path: '/admin/videos', label: '🎬 유튜브 관리', enabled: true },
  { path: '/admin/bookings', label: '📅 예약 확인', enabled: true },
  { path: '/admin/profiles', label: '👥 고객 프로필', enabled: true },
  { path: '/admin/dealers', label: '🤝 제휴 문의', enabled: true },
  { path: '/admin/used-car', label: '🚗 중고차 문의', enabled: true },
  { path: '/admin/pricing', label: '💰 가격 수정', enabled: true },
  { path: '/admin/users', label: '🔑 관리자 권한', enabled: true },
  { path: '/admin/faq', label: '❓ FAQ 관리', enabled: true },
  { path: '/admin/community', label: '📋 커뮤니티 모더레이션', enabled: true },
];

const HOME_LINK_STYLE = {
  display: 'block', padding: '8px 12px', marginBottom: 8,
  color: 'var(--text-muted)', fontSize: '0.9rem',
  borderBottom: '1px solid var(--border)',
};

export default function AdminLayout() {
  const { user, isAdmin, isLoading, signOut } = useAuth();
  const navigate = useNavigate();
  if (isLoading) return (
    <div className="admin-layout" style={{ justifyContent: 'center', alignItems: 'center' }}>
      <p style={{ color: 'var(--text-muted)' }}>로딩 중...</p>
    </div>
  );
  if (!user || !isAdmin) return <Navigate to="/login" replace />;
  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        <Link to="/" className="admin-sidebar-title" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>🔧 Admin</Link>
        <Link to="/" style={HOME_LINK_STYLE}>🏠 홈으로 돌아가기</Link>
        {MENU.map(item => (
          item.enabled ? (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => `admin-menu-item${isActive ? ' active' : ''}`}>{item.label}</NavLink>
          ) : (
            <span key={item.path} className="admin-menu-item disabled">{item.label}<span className="admin-menu-badge">준비 중</span></span>
          )
        ))}
        <button className="admin-menu-item" style={{ marginTop: 'auto', border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left', width: '100%' }}
          onClick={async () => { await signOut(); navigate('/'); }}>🚪 로그아웃</button>
      </nav>
      <div className="admin-content"><Outlet /></div>
    </div>
  );
}

export function AdminIndex() { return <Navigate to="/admin/images" replace />; }
